<script setup>
import { provide, shallowRef } from 'vue';
import { useI18n } from 'vue-i18n';

import LegacyCampaignsIndex from 'dashboard/routes/dashboard/settings/campaigns/Index.vue';

const { t } = useI18n();

const headerActions = shallowRef(null);

provide('setHeaderActions', component => {
  headerActions.value = component;
});
</script>

<template>
  <section class="flex flex-col w-full h-full overflow-hidden bg-n-surface-1">
    <header class="sticky top-0 z-10 px-6 lg:px-0">
      <div class="w-full max-w-[60rem] mx-auto">
        <div class="flex items-center justify-between w-full h-20 gap-2">
          <span class="text-xl font-medium text-n-slate-12">
            {{ t('CAMPAIGN.WHATSAPP.HEADER_TITLE') }}
          </span>
          <component :is="headerActions" v-if="headerActions" />
        </div>
      </div>
    </header>
    <main class="flex-1 px-6 overflow-y-auto lg:px-0">
      <div class="w-full max-w-[60rem] mx-auto py-4">
        <LegacyCampaignsIndex />
      </div>
    </main>
  </section>
</template>
